// ────────────────────────────────────────────────────────────
// SMALL UTILITIES
// ────────────────────────────────────────────────────────────

export function uid(prefix = ''): string {
  const r = Math.random().toString(36).slice(2, 8);
  return prefix ? `${prefix}_${Date.now().toString(36)}_${r}` : `${Date.now().toString(36)}_${r}`;
}

export function nowIso(): string { return new Date().toISOString(); }

export function relativeTime(iso: string): string {
  const d = Date.now() - new Date(iso).getTime();
  const m = Math.floor(d / 60_000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
}

export function formatDate(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
}

export function formatTime(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

// ─── INLINE MARKDOWN-LITE RENDERER ──────────────────────────
// Supports **bold**, *italic*, `code`, and ~uncertain~ ... ~
// Returns HTML string — used inside dangerouslySetInnerHTML carefully
// (only on author-trusted content like seed data and Claude output).
export function renderInlineMd(s: string): string {
  if (!s) return '';
  let out = s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  // ~uncertain~text~  → highlight (for Claude flagging uncertainty)
  out = out.replace(/~uncertain~([^~]+)~/g, '<span class="uncertain">$1</span>');
  // **bold**
  out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  // *italic*
  out = out.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  // `code`
  out = out.replace(/`([^`]+)`/g, '<code>$1</code>');
  // line breaks
  out = out.replace(/\n/g, '<br>');
  return out;
}

export function clamp(n: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, n));
}

export function activityTierFromLastSeen(lastSeen?: string): 'Hot' | 'Warm' | 'Cooling' | 'Dormant' | 'Unknown' {
  if (!lastSeen) return 'Unknown';
  const days = Math.floor((Date.now() - new Date(lastSeen).getTime()) / 86_400_000);
  if (days <= 90)  return 'Hot';
  if (days <= 365) return 'Warm';
  if (days <= 730) return 'Cooling';
  return 'Dormant';
}
